export default "__VITE_ASSET__ZuIfu0yj__"